var $db12283b528bfe21$exports = {};
// Theme toggle: dark (atelier default) <-> light, persisted across visits.
// No-JS fallback is out of scope: pages ship data-theme="dark" and stay there without JS.
const $db12283b528bfe21$var$THEME_KEY = "portfolio-theme";
const $db12283b528bfe21$var$root = document.documentElement;
const $db12283b528bfe21$var$button = document.querySelector(".theme-toggle");
function $db12283b528bfe21$var$stored() {
    try {
        const value = localStorage.getItem($db12283b528bfe21$var$THEME_KEY);
        if (value === "light" || value === "dark") return value;
    } catch (e) {
    /* storage unavailable — fall through to markup default */ }
    return $db12283b528bfe21$var$root.getAttribute("data-theme") === "light" ? "light" : "dark";
}
function $db12283b528bfe21$var$render(theme) {
    $db12283b528bfe21$var$root.setAttribute("data-theme", theme);
    const next = theme === "dark" ? "light" : "dark";
    if ($db12283b528bfe21$var$button) $db12283b528bfe21$var$button.setAttribute("aria-label", "Switch to " + next + " theme");
    if ($db12283b528bfe21$var$button) $db12283b528bfe21$var$button.textContent = theme === "dark" ? "Dark" : "Light";
}
$db12283b528bfe21$var$render($db12283b528bfe21$var$stored());
if ($db12283b528bfe21$var$button) $db12283b528bfe21$var$button.addEventListener("click", ()=>{
    const next = $db12283b528bfe21$var$stored() === "dark" ? "light" : "dark";
    try {
        localStorage.setItem($db12283b528bfe21$var$THEME_KEY, next);
    } catch (e) {
    /* theme still applies for this visit via render() */ }
    $db12283b528bfe21$var$render(next);
});


//# sourceMappingURL=404.98b0b322.js.map
